// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
export enum GroundTruthCounter {
	Default = 0,
	OmniVision = 1,
	Claude = 2,
	Groq = 3,
}

export const GroundTruthCounterDisplayNames: { [key in keyof typeof GroundTruthCounter]?: string} = {
	"Default": "Default",
	0 : "Default",
	"OmniVision": "OmniVision",
	1 : "OmniVision",
	"Claude": "Claude",
	2 : "Claude",
	"Groq": "Groq",
	3 : "Groq",
}

export const getGroundTruthCounterDisplayName = (key: GroundTruthCounter | (keyof typeof GroundTruthCounter & string)) => {
	return GroundTruthCounterDisplayNames[key];
}

